import { Button } from "@/components/common/Button";
import Input from "@/components/common/Input";
import { TelegramAuthButton } from "@/modules/auth";
import { WalletConnect } from "@/modules/auth/components/WalletConnect";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type EmailProps = {
  email: string;
  onEmailChange: (email: string) => void;
  onSubmit: (email: string) => void;
  resendCooldown: number;
  isLoading: boolean;
};

const Email = ({
  email: initialEmail,
  onEmailChange,
  onSubmit,
  resendCooldown,
  isLoading,
}: EmailProps) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(initialEmail);
  const [isValid, setIsValid] = useState(false);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    setEmail(initialEmail);
  }, [initialEmail]);

  useEffect(() => {
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setIsValid(valid);
    onEmailChange(email);
  }, [email, onEmailChange]);

  return (
    <div className="w-full flex flex-col items-center justify-center gap-8 px-4">
      {!connected && (
        <>
          <div className="w-full flex flex-col">
            <p className="text-[1.0625rem] leading-[1.375rem] font-semibold text-center">
              {t("auth.email.title")}
            </p>
            <p className="p-4 pb-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter uppercase">
              {t("auth.email.label")}
            </p>
            <Input
              placeholder="example@email.com"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              inputMode="email"
            />
            <p className="px-4 pt-4 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter text-center">
              {t("auth.email.description")}
            </p>
          </div>
          <Button
            onClick={() => onSubmit(email)}
            text={
              resendCooldown > 0
                ? t("auth.timer", { seconds: resendCooldown })
                : t("auth.email.button")
            }
            size="large"
            className="w-full"
            disabled={!isValid || resendCooldown > 0}
            loading={isLoading}
          />

          <TelegramAuthButton />
        </>
      )}

      <WalletConnect setConnected={setConnected} />
    </div>
  );
};

export default Email;
